var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "72acde3533"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "37e92f92f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 0 C 100.757812 0 30.4375 70.320312 30.4375 157.0625 C 30.4375 243.804688 100.757812 314.125 187.5 314.125 C 274.242188 314.125 344.5625 243.804688 344.5625 157.0625 C 344.5625 70.320312 274.242188 0 187.5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b91892e181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.125 270.328125 L 296 270.328125 L 296 375 L 79.125 375 Z M 79.125 270.328125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0b77e0163c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 375 L 295.875 270.328125 L 79.125 270.328125 L 187.5 375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d469352d08"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "182c9f8f76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 8.738281 C 104.800781 8.738281 37.757812 75.78125 37.757812 158.480469 C 37.757812 241.179688 104.800781 308.222656 187.5 308.222656 C 270.199219 308.222656 337.242188 241.179688 337.242188 158.480469 C 337.242188 75.78125 270.199219 8.738281 187.5 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f5d773569"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.175781 266.46875 L 291 266.46875 L 291 367 L 84.175781 367 Z M 84.175781 266.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7dba219d85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 366.261719 L 290.824219 266.46875 L 84.175781 266.46875 L 187.5 366.261719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "080720428d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7f1a4bb922"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 19.507812 C 110.746094 19.507812 48.527344 81.726562 48.527344 158.480469 C 48.527344 235.234375 110.746094 297.453125 187.5 297.453125 C 264.253906 297.453125 326.472656 235.234375 326.472656 158.480469 C 326.472656 81.726562 264.253906 19.507812 187.5 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a3f9395c98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 230.332031 100.402344 L 326.550781 100.402344 L 326.550781 214.113281 L 230.332031 214.113281 Z M 230.332031 100.402344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb027bbf2c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.527344 100.402344 L 148.703125 100.402344 L 148.703125 214.113281 L 48.527344 214.113281 Z M 48.527344 100.402344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bcd5cd1cbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 157.625 138.773438 L 221.625 138.773438 L 221.625 175.59375 L 157.625 175.59375 Z M 157.625 138.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53de6ee174"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 176.472656 138.773438 L 157.625 157.183594 L 176.472656 175.59375 L 176.472656 166.390625 L 202.734375 166.390625 L 202.734375 175.59375 L 221.585938 157.183594 L 202.734375 138.773438 L 202.734375 147.976562 L 176.472656 147.976562 L 176.472656 138.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0df4376059"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 157.625 138.773438 L 221.769531 138.773438 L 221.769531 175.945312 L 157.625 175.945312 Z M 157.625 138.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fbcf202989"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 176.527344 138.773438 L 157.625 157.359375 L 176.527344 175.945312 L 176.527344 166.652344 L 202.867188 166.652344 L 202.867188 175.945312 L 221.769531 157.359375 L 202.867188 138.773438 L 202.867188 148.066406 L 176.527344 148.066406 L 176.527344 138.773438 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72acde3533)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#37e92f92f7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b91892e181)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0b77e0163c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 79.125 270.328125 L 296.183594 270.328125 L 296.183594 374.792969 L 79.125 374.792969 Z M 79.125 270.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d469352d08)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#182c9f8f76)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f5d773569)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7dba219d85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 84.175781 266.46875 L 291.117188 266.46875 L 291.117188 366.066406 L 84.175781 366.066406 Z M 84.175781 266.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#080720428d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f1a4bb922)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a3f9395c98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 397.121094 154.308594 L 369.65625 121.40625 C 368.371094 119.863281 366.484375 118.980469 364.484375 118.980469 L 339.769531 118.980469 L 339.769531 107.183594 C 339.769531 103.453125 336.742188 100.421875 333.023438 100.421875 L 237.0625 100.421875 C 233.34375 100.421875 230.316406 103.453125 230.316406 107.183594 L 230.316406 191.554688 C 230.316406 195.28125 233.34375 198.316406 237.0625 198.316406 L 250.632812 198.316406 C 251.621094 207.160156 259.125 214.0625 268.207031 214.0625 C 277.292969 214.0625 284.796875 207.160156 285.78125 198.316406 L 333.023438 198.316406 C 334.25 198.316406 335.402344 197.980469 336.394531 197.402344 C 337.386719 197.976562 338.53125 198.3125 339.757812 198.3125 L 348.277344 198.3125 C 349.265625 207.160156 356.769531 214.0625 365.851562 214.0625 C 374.9375 214.0625 382.441406 207.160156 383.429688 198.3125 L 391.949219 198.3125 C 395.667969 198.3125 398.691406 195.28125 398.691406 191.550781 L 398.691406 158.648438 C 398.691406 157.0625 398.132812 155.519531 397.121094 154.308594 Z M 237.0625 107.191406 L 333.015625 107.183594 L 333.015625 125.703125 C 333.015625 125.714844 333.015625 125.726562 333.015625 125.742188 L 333.015625 191.542969 L 285.234375 191.542969 C 283.144531 184.089844 276.304688 178.601562 268.207031 178.601562 C 260.109375 178.601562 253.269531 184.089844 251.179688 191.546875 L 237.074219 191.554688 Z M 268.207031 207.289062 C 262.179688 207.289062 257.277344 202.375 257.277344 196.332031 C 257.277344 190.289062 262.179688 185.375 268.207031 185.375 C 274.234375 185.375 279.140625 190.289062 279.140625 196.332031 C 279.140625 202.375 274.234375 207.289062 268.207031 207.289062 Z M 365.851562 207.289062 C 359.824219 207.289062 354.921875 202.375 354.921875 196.332031 C 354.921875 190.289062 359.824219 185.375 365.851562 185.375 C 371.882812 185.375 376.785156 190.289062 376.785156 196.332031 C 376.785156 202.375 371.882812 207.289062 365.851562 207.289062 Z M 382.878906 191.542969 C 380.789062 184.085938 373.949219 178.601562 365.851562 178.601562 C 357.753906 178.601562 350.917969 184.085938 348.828125 191.542969 L 339.769531 191.550781 L 339.769531 125.753906 L 364.472656 125.75 L 391.9375 158.648438 L 391.949219 191.542969 Z M 382.878906 191.542969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb027bbf2c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 147.109375 154.308594 L 119.644531 121.40625 C 118.359375 119.863281 116.476562 118.980469 114.472656 118.980469 L 89.757812 118.980469 L 89.757812 107.183594 C 89.757812 103.453125 86.734375 100.421875 83.011719 100.421875 L -12.945312 100.421875 C -16.664062 100.421875 -19.691406 103.453125 -19.691406 107.183594 L -19.691406 191.554688 C -19.691406 195.28125 -16.664062 198.316406 -12.945312 198.316406 L 0.625 198.316406 C 1.609375 207.160156 9.113281 214.0625 18.199219 214.0625 C 27.28125 214.0625 34.785156 207.160156 35.773438 198.316406 L 83.011719 198.316406 C 84.242188 198.316406 85.390625 197.980469 86.382812 197.402344 C 87.375 197.976562 88.523438 198.3125 89.75 198.3125 L 98.269531 198.3125 C 99.253906 207.160156 106.757812 214.0625 115.84375 214.0625 C 124.929688 214.0625 132.433594 207.160156 133.417969 198.3125 L 141.9375 198.3125 C 145.65625 198.3125 148.683594 195.28125 148.683594 191.550781 L 148.683594 158.648438 C 148.683594 157.0625 148.125 155.519531 147.109375 154.308594 Z M -12.945312 107.191406 L 83.003906 107.183594 L 83.003906 125.703125 C 83.003906 125.714844 83.003906 125.726562 83.003906 125.742188 L 83.003906 191.542969 L 35.226562 191.542969 C 33.136719 184.089844 26.296875 178.601562 18.199219 178.601562 C 10.101562 178.601562 3.261719 184.089844 1.171875 191.546875 L -12.9375 191.554688 Z M 18.199219 207.289062 C 12.171875 207.289062 7.265625 202.375 7.265625 196.332031 C 7.265625 190.289062 12.171875 185.375 18.199219 185.375 C 24.226562 185.375 29.128906 190.289062 29.128906 196.332031 C 29.128906 202.375 24.226562 207.289062 18.199219 207.289062 Z M 115.84375 207.289062 C 109.816406 207.289062 104.910156 202.375 104.910156 196.332031 C 104.910156 190.289062 109.816406 185.375 115.84375 185.375 C 121.871094 185.375 126.777344 190.289062 126.777344 196.332031 C 126.777344 202.375 121.871094 207.289062 115.84375 207.289062 Z M 132.871094 191.542969 C 130.777344 184.085938 123.941406 178.601562 115.84375 178.601562 C 107.746094 178.601562 100.90625 184.085938 98.816406 191.542969 L 89.757812 191.550781 L 89.757812 125.753906 L 114.464844 125.75 L 141.925781 158.648438 L 141.9375 191.542969 Z M 132.871094 191.542969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 113.902344 133.222656 C 113.261719 132.453125 112.3125 132.007812 111.316406 132.007812 L 96.484375 132.007812 C 94.621094 132.007812 93.117188 133.519531 93.117188 135.382812 L 93.117188 152.257812 C 93.117188 154.121094 94.621094 155.628906 96.484375 155.628906 L 125.339844 155.628906 C 128.195312 155.628906 129.753906 152.292969 127.929688 150.097656 Z M 113.902344 133.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bcd5cd1cbf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53de6ee174)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 157.625 138.773438 L 221.625 138.773438 L 221.625 175.59375 L 157.625 175.59375 Z M 157.625 138.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0df4376059)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fbcf202989)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.731128, 0, 0, 0.73591, 157.624564, 138.775097)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 25.854285 -0.00225542 L 0.000596682 25.253464 L 25.854285 50.509184 L 25.854285 37.881324 L 61.880617 37.881324 L 61.880617 50.509184 L 87.734305 25.253464 L 61.880617 -0.00225542 L 61.880617 12.625604 L 25.854285 12.625604 L 25.854285 -0.00225542 ",
    stroke: "#000000",
    strokeWidth: 18.520531,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.5c76bc89100e1ce8c4a58c5f2acbc1da.svg";
export { ForwardRef as ReactComponent };